var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"inline w-2 mr-1",attrs:{"src":"/static/img/icons/icons8-asterisk-filled-50.png"}})}
var staticRenderFns = []

export { render, staticRenderFns }